export default {
    mapper: {
        relations: {
            belongsTo: {
                address: {
                    foreignKey: 'address_id',
                    localField: 'address',
                },
                shippingMethod: {
                    foreignKey: 'shipping_method_id',
                    localField: 'shippingMethod',
                },
            },
        },
    },
};
